import { gql } from 'graphql-request';
import {
  LifestyleID,
  LifestyleUUID,
  LifestyleImageID,
  LifestyleImageName,
  LifestyleImageFile,
  LifestyleImageSize,
  LifestyleImageUUID,
  LifestyleNanoID
} from '../lifestylesTypes';

export interface CacheFetchShowLifestyleImageQueryResponseImage {
  id: LifestyleImageID;
  uuid: LifestyleImageUUID;
  file: LifestyleImageFile;
  size: LifestyleImageSize;
  name: LifestyleImageName;
}

export interface CacheFetchShowLifestyleImageQueryResponse {
  id: LifestyleID;
  nanoId: LifestyleNanoID;
  uuid: LifestyleUUID;
  image: CacheFetchShowLifestyleImageQueryResponseImage;
}

export const CACHE_FETCH_SHOW_LIFESTYLE_IMAGE_QUERY = gql`
  query CacheShowLifestyleImage($uuid: ID!, $source: String) {
    lifestyle(uuid: $uuid, source: $source) {
      id
      nanoId
      uuid
      image {
        id
        uuid
        size
        name
        file
      }
    }
  }
`;
